// Danışman notu — plan §6.4. Kolapslanabilir textarea her soru altında.
// Not AI prompt'una bağlam olarak aktarılır (M6).

import { useState } from "react";
import { CONSULTANT_NOTE_MAX_LENGTH } from "@mahir/shared";
import { CONSULTANT_NOTE_COPY } from "../../lib/form-save-copy";

// UX P1 I1 — sunucu sınırı (öğe şeması) ile aynı; %90'dan sonra sayaç görünür.
const NEAR_LIMIT = Math.floor(CONSULTANT_NOTE_MAX_LENGTH * 0.9);

interface Props {
  questionCode: string;
  value: string;
  onChange: (v: string) => void;
}

export function ConsultantNote({ value, onChange }: Props): JSX.Element {
  const [expanded, setExpanded] = useState(value.length > 0);

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded((e) => !e)}
        className="text-xs flex items-center gap-1"
        style={{
          color: value.length > 0 ? "var(--color-primary)" : "var(--color-text-3)",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <span>{expanded ? "▾" : "▸"}</span>
        <span>
          Danışman notu
          {value.length > 0 && (
            <span style={{ fontFamily: "var(--font-mono)", marginLeft: 4, fontSize: "0.7rem" }}>
              ({value.length})
            </span>
          )}
        </span>
      </button>
      {expanded && (
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={CONSULTANT_NOTE_MAX_LENGTH}
          rows={2}
          placeholder="AI üretimine bağlam olarak verilecek özel not…"
          className="mt-1 w-full rounded-lg px-3 py-2 text-xs resize-none"
          style={{
            background: "var(--color-bg)",
            border: "1px solid var(--color-border)",
            color: "var(--color-text-2)",
            fontFamily: "var(--font-sans)",
          }}
        />
      )}
      {expanded && value.length >= NEAR_LIMIT && (
        <p
          className="mt-1 text-xs"
          data-testid="consultant-note-limit"
          style={{
            color:
              value.length >= CONSULTANT_NOTE_MAX_LENGTH
                ? "var(--color-error)"
                : "var(--color-text-3)",
          }}
        >
          {value.length >= CONSULTANT_NOTE_MAX_LENGTH
            ? CONSULTANT_NOTE_COPY.atLimit(CONSULTANT_NOTE_MAX_LENGTH)
            : CONSULTANT_NOTE_COPY.nearLimit(value.length, CONSULTANT_NOTE_MAX_LENGTH)}
        </p>
      )}
    </div>
  );
}
